import React from "react";
import GoogleChart from "../../../../../components/googleChart/googleChart";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/packagesSales/packagesSales";
import LoadingAnimation from "../../../../../components/loadingAnimation/loadingAnimation";

const TableOrLineChart = () => {
  const dispatch = useDispatch();
  const {
    selectedFilters: { table_view },
    chartData: { data_table },
    chartData,
    chartInfo: { status }
  } = useSelector((state) => state.packagesSales);

  if (status === "idle") return null;

  if (status === "loading") return <LoadingAnimation text="Updating data..." />;

  const switchView = (data) => {
    dispatch(actionCreators.updateTableView(data));
  };

  return (
    <GoogleChart
      chartName="packages_sales_chart"
      width="1350px"
      height="400"
      isTableView={table_view}
      rows={data_table?.rows ?? []}
      columns={data_table?.cols ?? []}
      options={chartData?.options}
      enableEventListeners={true}
      chartType={table_view ? "Table" : "LineChart"}
      showAdditionTooltip={false}
      showXLSX={table_view}
      switchView={switchView}
    />
  );
};

export default TableOrLineChart;
